<template>
  <div class="camera-wrapper">
    <video
      ref="video"
      autoplay
      playsinline
      muted
      :style="videoStyle"
      class="camera-video"
    ></video>

    <div class="camera-overlay">
      <div class="face-frame"></div>
    </div>

    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
</template>

<script>
export default {
  name: 'CameraView',

  props: {
    ativo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      stream: null,
      devices: [],
      currentDeviceIndex: 0
    };
  },

  watch: {
    ativo: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.abrirCamera();
          await this.inicializarDispositivos();
        } else {
          this.fecharCamera();
        }
      }
    }
  },

  computed: {
    videoStyle() {
      return {
        width: '100%',
        borderRadius: '8px',
        transform: this.facingMode === 'user' ? 'scaleX(-1)' : 'none'
      }
    }
  },

  methods: {
    async inicializarDispositivos() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.devices = devices.filter(d => d.kind === 'videoinput');
      this.$emit('cameras-detectadas', this.devices.length);
    },

    async abrirCamera() {
      // segurança: fecha qualquer stream anterior
      this.fecharCamera();

      const device = this.devices[this.currentDeviceIndex];

      const constraints = {
        video: device
          ? { deviceId: { exact: device.deviceId } }
          : { facingMode: 'environment' }
      };

      this.stream = await navigator.mediaDevices.getUserMedia(constraints);

      const video = this.$refs.video;
      video.srcObject = this.stream;

      await video.play();
    },

    fecharCamera() {
      // 🔴 ESSA PARTE É O QUE RESOLVE SEU PROBLEMA
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }

      if (this.$refs.video) {
        this.$refs.video.pause();
        this.$refs.video.srcObject = null;
      }
    },

    alternarCamera() {
      if (this.devices.length < 2) return;

      this.currentDeviceIndex =
        (this.currentDeviceIndex + 1) % this.devices.length;

      this.abrirCamera();
    },

    capturar() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);

      return canvas.toDataURL('image/jpeg', 0.9);
    }
  },

  beforeDestroy() {
    this.fecharCamera();
  }
};
</script>

<style>
  .camera-wrapper {
    position: relative;
    width: 100%;
    padding-top: 75%; 
    background-color: black;
    overflow: hidden;
    border-radius: 8px;
  }

  .camera-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .camera-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    padding: 0;
  }

  .face-frame {
    width: 40%; 
    height: 0;
    padding-bottom: 55%; 
    border: 3px dashed white;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.6);
  }
</style>